import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material'
import React,{useState} from 'react'
import styled from "@emotion/styled";

import ReactApexChart from 'react-apexcharts'
import {COLOR} from '../constants';
import { customRound } from '../utils/utils';


function LineGraph({
  title='Title', 
  isImprove=true, 
  score=10, 
  percentage=10,
  gData=[],
  handleBoxClick=()=>{},
  captionText='Your Text'

}) {

  const StyledCardActions = styled(CardActions)({
    padding:'5px',
    backgroundColor: '#def1fc',
    "&:hover": {backgroundColor : "#1976d2", color:'#fff' }
  });


    const data = {  
      series: [{
          name: "",
          data: gData, //[109, 41, 25, 51, 19, 62, 19, 9, 8]
      }],
    options: {
      chart: {
        type: 'area',
        zoom: {
          enabled: false
        },
        toolbar: {
            show: false
        },
        sparkline: {
          enabled: true
       }
      },
      colors: ['#2E93fA'],
      markers: {
        size: 2,
        strokeColors: '#1976d2',
      } ,         
      tooltip: {
        enabled: true,
        shared: false,
        intersect: false,
        style: {
          fontSize: '10px',
          fontFamily: undefined
        },
        marker: {
          show: false,
        },
        followCursor:false,
  
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width:2,
        curve: 'straight'
      },
    },       
      };

  return (
    <Card sx={{ width: 375, height:120, margin: '0px 4px', boxShadow:0, border:'1px solid #ccc'}}>
      <StyledCardActions>
        <Box onClick={handleBoxClick} sx={{display:'flex', width:'100%', alignItems:'center'}}>
            <Typography component={'div'} sx={{width:'50%',marginRight:'5px',fontSize:'12px', fontWeight:600}}> 
              {title} &nbsp;
            </Typography>
            <div style={{width:'50%',display:'flex'}}>
            <span style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'20px'}}>{score}</span>
              <div style={{fontFamily: 'Open Sans',width:'30%',
                  color:`${isImprove ? COLOR.PERCENTAGE_IN_GREEN : COLOR.PERCENTAGE_IN_RED}`,fontWeight:800, fontSize:12}}> 
                {customRound(percentage, 2)}% 
                <div style={{fontSize:'7px',fontStyle:'italic', textWrap:'nowrap', fontWeight:'bold', marginLeft:'1px'}} >
                  {captionText && <>(captionText)</>}
                </div>
              </div>
            </div>
        </Box>
      </StyledCardActions>
      <CardContent sx={{padding:'1px'}}>
          <ReactApexChart options={data.options} series={data.series} type="area" height={80} />
      </CardContent>
    </Card>
  )
}

export default LineGraph